<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="gray--text mb-3 insurance-step-modality__title">
          SEGURADORA: {{ insurance.nome }}
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-5">
      <v-col cols="12" sm="4" md="3" class="pb-5 pb-sm-0">
        <BaseButton
          class="secondary white--text"
          width="100%"
          @click="newModality"
        >
          <v-icon class="pr-3">
            fa-plus
          </v-icon>
          INCLUIR MODALIDADE
        </BaseButton>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="4" md="3" v-if="hasModality && selectedItemToDelete">
        <BaseButton
          color="pink"
          width="100%"
          outlined
          v-html="'EXCLUIR MODALIDADE'"
          @click="removeSelectedModality"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <BaseDataTable
          :headers="header"
          :items="form.modalidades"
          show-select
          item-key="modalidade.nome"
          v-model="selectedModality"
          hide-default-footer
          no-data-text="Não existem modalidades cadastradas para esta seguradora"
        >
          <!-- Não posso usar o click:row, por causa do botão -->
          <!-- Assim terei que colocar click por template -->
          <!-- Já que o cliente deseja este tipo de interação -->
          <template v-slot:[`item.modalidade.nome`]="{ item }">
            <div @click="editItem(item)" class="insurance-step-modality__row">
              {{ item.modalidade.nome }}
            </div>
          </template>
          <template v-slot:[`item.prazo_minuta_dias`]="{ item }">
            <div @click="editItem(item)" class="insurance-step-modality__row">
              {{ item.prazo_minuta_dias }} dias
            </div>
          </template>
          <template v-slot:[`item.prazo_apolice_dias`]="{ item }">
            <div @click="editItem(item)" class="insurance-step-modality__row">
              {{ item.prazo_apolice_dias }} dias
            </div>
          </template>
          <template v-slot:[`item.valor_emissao_sem_ccg`]="{ item }">
            <div @click="editItem(item)" class="insurance-step-modality__row">
              {{ convertNumberToMoney(item.valor_emissao_sem_ccg) }}
            </div>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <div @click="editItem(item)">
              {{ isActivate(item) }}
            </div>
          </template>
        </BaseDataTable>
      </v-col>
      <v-col cols="12" class="pt-10 pb-9">
        <v-divider />
      </v-col>
    </v-row>
    <v-row v-if="hasModality">
      <v-col cols="12">
        <p class="primary--text form__title mb-6">
          CONFIGURAÇÃO DE ACESSO/TROCA DE ARQUIVOS
        </p>
      </v-col>
      <v-col cols="12" class="pb-5">
        <v-switch
          v-model="form.aceita_link_arquivos"
          class="pa-0 ma-0 justify-self-center d-inline-block insurance-step-modality__switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Aceita receber arquivos através do link
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormInput
          id-element="address"
          placeholder="Inserir"
          v-model="form.tamanho_maximo_arquivos_mb"
          type="number"
          label-text="Tamanho máximo de Arquivo"
        />
      </v-col>
    </v-row>
    <BaseFooter v-if="hasModality">
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="white--text pink"
            width="100%"
            :to="{ name: 'insurance_company' }"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'FINALIZAR'"
            class="white--text secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "Modalidade", value: "modalidade.nome", sortable: true },
  { text: "Prazo Emissão Minuta", value: "prazo_minuta_dias", sortable: true },
  {
    text: "Prazo Emissão Apólice",
    value: "prazo_apolice_dias",
    sortable: true
  },
  { text: "Limite sem CCG", value: "valor_emissao_sem_ccg", sortable: true },
  { text: "Status", value: "ativo", sortable: true }
];
import { requiredInput } from "@/utils/rules.js";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { mapActions } from "vuex";
import { asMoneyString, convertNumberToMoney } from "@/utils/formats.js";
export default {
  data: () => ({
    header: tableHeaders,
    requiredInput,
    selectedModality: [],
    asMoneyString,
    convertNumberToMoney
  }),
  mixins: [InsuranceCompanyMixin],
  computed: {
    hasModality() {
      return this.form.modalidades.length > 0;
    },
    formStep() {
      return {
        name: "insurance_company step form",
        step: 1
      };
    },
    selectModalityStep() {
      return {
        name: "insurance_company select modality",
        step: 2
      };
    },
    editModality() {
      return {
        name: "insurance_company edit modality",
        step: 2
      };
    },
    selectedItemToDelete() {
      return this.selectedModality.length > 0;
    }
  },
  methods: {
    ...mapActions(["showAlertNotification"]),
    newModality() {
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(this.form, this.selectModalityStep)
      );
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    },
    editItem(item) {
      this.$emit(
        "editModality",
        this.payloadInsuranceCompany(this.form, this.editModality, item)
      );
    },
    isActivate(item) {
      return item.ativo ? "Ativo" : "Inativo";
    },
    removeSelectedModality() {
      this.form.modalidades = this.form.modalidades.filter(
        item => !this.selectedModality.includes(item)
      );
    }
  },
  props: {
    return: {
      type: Boolean
    },
    form: {
      type: Object
    },
    insurance: {
      type: Object
    }
  },
  watch: {
    return(value) {
      if (value)
        this.$emit(
          "updateStep",
          this.payloadInsuranceCompany(this.form, this.formStep)
        );
    }
  }
};
</script>
<style lang="sass">
.insurance-step-modality__
  &title
    font-weight: 800
    font-size: 18px
  &row
    cursor: pointer
</style>
